import React, { useState } from 'react';
import {
  ALIGNMENTS_ROW_EXAMS,
  COLUMNS_DEVICE_EXAMS,
  HEADERS_TABLE_EXAMS,
  EXCLUDED_COLUMNS,
  TEXT_CLASS,
  COLOR_DISABLED,
  COLOR_TEXT_INFO
} from '../../constants';
import constants from '@/core/constants';
import { ICourseExam, IMapCourseExam } from '../types';
import ReusableButton from '@/presentation/reusables/Button';
import { InfoContentModal } from '../ContentModal/InfoContentModal';
import { TableCourse } from '@/presentation/reusables/Table/TableCourse';

interface IExamsViewDesktop {
  typeExam: string;
  dateExam: string;
  coursesData: ICourseExam[];
}

export const ExamsViewDesktop = ({
  typeExam,
  dateExam,
  coursesData
}: IExamsViewDesktop) => {
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [courseSelected, setCourseSelected] = useState<IMapCourseExam | null>(
    null
  );
  const validateIsPresential = (modality: string) =>
    modality === constants.CARD_TYPES.CURSO_PRESENCIAL;

  const rowsData: ICourseExam[] = coursesData?.map(
    (course): IMapCourseExam => ({
      id: course.id,
      name: course.name,
      start: course.start,
      end: course.end,
      about: course.about,
      urlExamClass: course.urlExamClass,
      classroom: validateIsPresential(course.modality)
        ? course.location?.classroom
        : TEXT_CLASS,
      pavilion: course.location?.pavilion ?? '',
      floor: course.location?.floor ?? '',
      address: course.location?.address ?? '',
      campus: course.location?.campus ?? '',
      sede: course.location?.sede ?? '',
      lat: course.location?.lat ?? 0,
      long: course.location?.long ?? 0,
      modality: course.modality,
      isDisabled: course.isDisabled
    })
  );

  const handlerMapCourseData = (row: IMapCourseExam) =>
    setCourseSelected({
      id: row.id,
      name: row.name,
      start: row.start,
      end: row.end,
      about: row.about,
      modality: row.modality,
      typeExam,
      date: `${dateExam} de ${row.start} a ${row.end}`,
      urlExamClass: row.urlExamClass,
      classroom: row.classroom,
      pavilion: row.pavilion,
      address: row.address,
      floor: row.floor,
      campus: row.campus,
      sede: row.sede,
      lat: row.lat,
      long: row.long,
      isDisabled: row.isDisabled
    });

  const handlerAction = (row: IMapCourseExam, isPresential: boolean) => {
    if (isPresential) {
      handlerMapCourseData(row);
      setOpenModalInfo(true);
      return;
    }
    document.open(row?.urlExamClass ?? '', '_blank', 'noopener,noreferrer');
  };

  const handlerCloseModal = () => {
    setCourseSelected(null);
    setOpenModalInfo(false);
  };

  const columnAction = (row: IMapCourseExam) => {
    const isPresential = validateIsPresential(row.modality);
    return (
      <ReusableButton
        iconAppend={isPresential ? 'arrow-right' : 'external-link'}
        disabled={row.isDisabled}
        sizeIcon={24}
        onClick={() => handlerAction(row, isPresential)}
        style={{
          width: isPresential ? '160px' : '150px',
          height: '40px',
          gap: '8px',
          padding: '0px 16px 0px 24px'
        }}
        outlined
      >
        {isPresential ? 'Ver ubicación' : 'Ir al examen'}
      </ReusableButton>
    );
  };

  return (
    <>
      <TableCourse
        headers={HEADERS_TABLE_EXAMS}
        columnWidths={COLUMNS_DEVICE_EXAMS}
        alignments={ALIGNMENTS_ROW_EXAMS}
        colorScroll="#B0C0CA"
        scrollActiveAt="1280px"
        data={rowsData}
        excludedColumns={EXCLUDED_COLUMNS}
        renderActions={(row: ICourseExam) => columnAction(row)}
        styleTable={{
          border: '0',
          borderRadius: '0'
        }}
        styleHeader={{
          height: '60px',
          border: '0',
          borderRadius: '0',
          backgroundColor: '#F5F5F5',
          borderBottom: '1px solid #DEDEDE',
          color: rowsData.every((row) => row.isDisabled)
            ? COLOR_DISABLED
            : COLOR_TEXT_INFO
        }}
        styleBody={{
          border: '0',
          padding: '0',
          borderRadius: '0'
        }}
        styleRow={{
          border: '0',
          borderTop: '0',
          borderRadius: '0',
          borderBottom: '1px solid #DEDEDE'
        }}
      />
      {courseSelected && (
        <InfoContentModal
          show={openModalInfo}
          onClose={() => handlerCloseModal()}
          dataCourseExam={courseSelected}
        />
      )}
    </>
  );
};
